import React from "react"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Card from "react-bootstrap/Card"
import CardGroup from "react-bootstrap/CardGroup"
import { Link } from "gatsby"
import "./cards.scss"
import Reveal from "react-reveal/Reveal"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"

const Cards = () => {
  const data = useStaticQuery(
    graphql`
      query {
        laptop: file(relativePath: { eq: "laptop.jpg" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        mobileApp: file(relativePath: { eq: "mobileApp.jpg" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        deskTop: file(relativePath: { eq: "deskTop.jpg" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  )
  return (
    <section className="row border-top mx-0 pt-xl-3 pt-lg-3 pt-md-3 cardsWrapper">
      <Col xs={12} sm={12} md={12} lg={12} xl={12}>
        <h2 className="text-center pt-3 m-auto mx-auto display-4 textGradent">
          My Awesome Projects
        </h2>
      </Col>
      <Col
        xs={12}
        sm={12}
        md={12}
        lg={9}
        xl={9}
        className="mx-0 m-auto px-0 py-1"
      >
        <CardGroup className="mx-0 mb-xl-4 mb-lg-4 mb-md-4">
          <Card className="mx-auto">
            <Img
              className="card.img cardImage"
              variant="top"
              fluid={data.laptop.childImageSharp.fluid}
            />
            <Card.Body className="panelBg">
              <Reveal bottom forever={true}>
                <Row className="card.text customCardText mx-0">
                  <Col className="m-auto px-0">
                    <p>
                      Bespoke websites and web apps development using cutting
                      edge latest technologies.
                    </p>
                  </Col>
                </Row>
              </Reveal>
              <hr
                className="mx-0 mt-0"
                style={{ background: "gray", marginBottom: "0px" }}
              />

              <Link
                to="/Blog"
                className="float-right text-secondary"
                type="button"
              >
                <abbr title="Blog Link" className="customLink">
                  Read More
                </abbr>
                <span className="text-danger">
                  <strong> &#62;</strong>
                </span>
              </Link>
            </Card.Body>
          </Card>
          <Card className="mx-auto mx-md-2 mx-lg-4 mx-xl-4">
            <Img
              className="card.img cardImage"
              variant="top"
              fluid={data.mobileApp.childImageSharp.fluid}
            />
            <Card.Body className="panelBg">
              <Reveal bottom forever={true}>
                <Row className="card.text customCardText px-0">
                  <Col className="m-auto mx-0">
                    <p>
                      Building Mobile Apps for IOS and Android with the best and
                      latest tech stack.
                    </p>
                  </Col>
                </Row>
              </Reveal>
              <hr
                className="mx-0 mt-0"
                style={{ background: "gray", marginBottom: "0px" }}
              />
              <Link
                to="/Blog"
                className="float-right text-secondary"
                type="button"
              >
                <abbr title="Blog Link" className="customLink">
                  Read More
                </abbr>
                <span className="text-danger">
                  <strong> &#62;</strong>
                </span>
              </Link>
            </Card.Body>
          </Card>
          <Card className="mx-auto">
            <Img
              className="card.img cardImage"
              variant="top"
              fluid={data.deskTop.childImageSharp.fluid}
            />
            <Card.Body className="panelBg">
              <Reveal bottom forever={true}>
                <Row className="card.text mx-0 customCardText">
                  <Col className="m-auto px-0">
                    <p>
                      I have excellent problem solving skills, organisational
                      and time management, accuracy and details.
                    </p>
                  </Col>
                </Row>
              </Reveal>
              <hr
                className="mx-0 mt-0"
                style={{ background: "gray", marginBottom: "0px" }}
              />
              <Link
                to="/Blog"
                className="float-right text-secondary"
                type="button"
              >
                <abbr title="Blog Link" className="customLink">
                  Read More
                </abbr>
                <span className="text-danger">
                  <strong> &#62;</strong>
                </span>
              </Link>
            </Card.Body>
          </Card>
        </CardGroup>
      </Col>
    </section>
  )
}

export default Cards
